import { gql } from "@apollo/client"
import { HIRING_FORM_EMPLOYMENT_FIELDS_FRAGMENT } from "~/app/fragments/HiringFormEmploymentFields"
import { Mutation, MutationUpdatePersonalDetailsArgs } from "@oysterhr/schema"
import { InjectedOptions, useMutation } from "@oysterhr/core"

const UpdatePersonalDetailsMutation = gql`
  ${HIRING_FORM_EMPLOYMENT_FIELDS_FRAGMENT}
  mutation UpdatePersonalDetails($input: UpdatePersonalDetailsInput!) {
    updatePersonalDetails(input: $input) {
      employment {
        ...HiringFormEmploymentFields
      }
      errors
      fieldErrors {
        fieldId
        message
        target
      }
    }
  }
`

type UseUpdatePersonalDetailsOptions = InjectedOptions<
  UseUpdatePersonalDetailsReturnType,
  MutationUpdatePersonalDetailsArgs
>

export type UseUpdatePersonalDetailsReturnType = {
  updatePersonalDetails: Mutation["updatePersonalDetails"]
}

type Options = UseUpdatePersonalDetailsOptions

/**
 * Use this hook to update personal details in the hiring form.
 */
export const useUpdatePersonalDetails = (options?: Options) => {
  return useMutation<UseUpdatePersonalDetailsReturnType, MutationUpdatePersonalDetailsArgs>(
    UpdatePersonalDetailsMutation,
    options,
  )
}
